// extracted by mini-css-extract-plugin
export default {"text":"Y5hEJ","logo":"Gb3Fd"};